"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const builder_1 = __importDefault(require("../../../utils/builder"));
const Evaluator_1 = require("../../../utils/Evaluator");
const utils_1 = __importDefault(require("../../../components/_classes/component/editForm/utils"));
const lodash_1 = __importDefault(require("lodash"));
exports.default = [
    {
        key: 'labelPosition',
        ignore: true,
    },
    {
        key: 'placeholder',
        ignore: true,
    },
    {
        key: 'hideLabel',
        customConditional(context) {
            var _a, _b;
            return (_b = (_a = context.instance.options) === null || _a === void 0 ? void 0 : _a.flags) === null || _b === void 0 ? void 0 : _b.inDataGrid;
        },
    },
    {
        key: 'dataGridLabel',
        ignore: true,
    },
    {
        type: 'select',
        key: 'action',
        label: 'Action',
        input: true,
        dataSrc: 'values',
        weight: 110,
        tooltip: 'This is the action to be performed by this button.',
        data: {
            values: [
                //Fiona        
                { label: 'Bpm Submit Init', value: 'bpmsubmit' },
                { label: 'Bpm Approve', value: 'bpmapprove' },
                { label: 'Bpm Reject', value: 'bpmreject' },
                { label: 'Bpm Do Task', value: 'bpmtask' },
                { label: 'Bpm Send Back', value: 'bpmsendback' },
                //end Fiona
                //Simple
                { label: 'POST to Ari Core', value: 'aripost' },
                { label: 'Redirect', value: 'swpage' },
                //End Simple
                { label: 'Submit', value: 'submit' },
                { label: 'Save in state', value: 'saveState' },
                { label: 'Event', value: 'event' },
                { label: 'Custom', value: 'custom' },
                { label: 'Reset', value: 'reset' },
                // { label: 'OAuth', value: 'oauth' },
                { label: 'POST to URL', value: 'url' },
                { label: 'Run Javacript', value: 'runjs' },
                { label: 'Back', value: 'back' }, //HungNQ
            ],
        },
    },
    // {
    //   type: 'textarea',
    //   label: 'Additional Params',
    //   key: 'additionalParams',
    //   rows: 5,
    //   editor: 'ace',
    //   as: 'handlebars',
    //   clearOnHide: false,
    //   weight: 111,
    //   input: true,
    //   customConditional({ data }) {
    //     const validActions = [
    //       'bpmtask',
    //       'bpmsubmit',
    //       'bpmapprove',
    //       'bpmreject',
    //       'bpmsendback'
    //     ];
    //     const allowEval = (!Evaluator.noeval || Evaluator.protectedEval);
    //     const matchAction = validActions.includes(data.action);
    //     return allowEval && !data.displayAsTable && matchAction;
    //   },
    // },
    utils_1.default.javaScriptValue('Additional Params', 'additionalParams', 'additionalParams', 111, '<p><h4>Example:</h4><pre>value = data.a + data.b + data.c;</pre></p>', '<p><h4>Example:</h4><pre>{"+": [{"var": "data.a"}, {"var": "data.b"}, {"var": "data.c"}]}</pre>', '<tr><th>token</th><td>The decoded JWT token for the authenticated user.</td></tr>'),
    //Fiona
    {
        type: 'select',
        key: 'actionType',
        label: 'Action Type',
        input: true,
        tooltip: 'The action of landing page',
        dataSrc: 'values',
        weight: 111,
        data: {
            values: [
                { label: 'List', value: 'LIST' },
                { label: 'Add', value: 'ADD' },
                { label: 'Edit', value: 'EDIT' },
                { label: 'View detail', value: 'VIEW' },
                { label: 'Delete', value: 'DEL' },
                { label: 'Block', value: 'BLOCK' },
                { label: 'Unblock', value: 'UNBLOCK' },
                { label: 'Approve', value: 'APPROVE' },
                { label: 'Do Task', value: 'DOTASK' }
            ],
        },
        conditional: {
            json: {
                and: [
                    { '!==': [{ var: 'data.action' }, 'bpmsubmit'] },
                    { '!==': [{ var: 'data.action' }, 'bpmapprove'] },
                    { '!==': [{ var: 'data.action' }, 'bpmreject'] },
                    { '!==': [{ var: 'data.action' }, 'bpmtask'] },
                    { '!==': [{ var: 'data.action' }, 'bpmsendback'] }
                ]
            }
        }
    },
    //end Fiona
    {
        type: 'select',
        key: 'oauthProvider',
        label: 'OAuth Provider',
        input: true,
        dataSrc: 'values',
        weight: 111,
        tooltip: 'The oauth provider to use to log in (8.x server only).',
        data: {
            values: [
                { label: 'OpenID', value: 'openid' },
                { label: 'Github', value: 'github' },
                { label: 'Google', value: 'google' },
            ],
        },
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'oauth'] },
        },
    },
    {
        type: 'textfield',
        label: 'Save in state',
        key: 'state',
        weight: 112,
        tooltip: 'The state you wish to save the submission under when this button is pressed. Example "draft" would save the submission in Draft Mode.',
        placeholder: 'submitted',
        input: true,
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'saveState'] },
        },
    },
    {
        type: 'checkbox',
        input: true,
        inputType: 'checkbox',
        key: 'saveOnEnter',
        label: 'Save On Enter',
        weight: 113,
        tooltip: 'Use the Enter key to submit form.',
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'submit'] },
        },
    },
    {
        type: 'checkbox',
        input: true,
        inputType: 'checkbox',
        key: 'showValidations',
        label: 'Show Validations',
        weight: 115,
        tooltip: 'When the button is pressed, show any validation errors on the form.',
        conditional: {
            json: { '!==': [{ var: 'data.action' }, 'submit'] },
        },
    },
    {
        type: 'checkbox',
        input: true,
        inputType: 'checkbox',
        key: 'redirectToStaticForm',
        label: 'Redirect to Static Form',
        weight: 113,
        tooltip: 'It will redirect to static form when click on button.',
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'swpage'] },
        },
    },
    {
        type: 'checkbox',
        input: true,
        inputType: 'checkbox',
        key: 'notDisableWhenSubmitBPM',
        label: 'Not Disable When Submit BPM',
        weight: 113,
        tooltip: 'It will not disable the button when submitting BPM.',
    },
    {
        type: 'checkbox',
        input: true,
        inputType: 'checkbox',
        key: 'backHeader',
        label: 'Button Back In Header',
        weight: 113,
        tooltip: 'When check button will replace button back in header of mobile.',
    },
    {
        type: 'textfield',
        label: 'Button Event',
        key: 'event',
        input: true,
        weight: 120,
        tooltip: 'The event to fire when the button is clicked.',
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'event'] },
        },
    },
    //Fiona
    {
        type: 'checkbox',
        input: true,
        inputType: 'checkbox',
        key: 'autodoaction',
        label: 'Auto add link api or link redirect',
        weight: 119,
        tooltip: 'Auto add link api or link redirect',
        conditional: {
            json: {
                and: [
                    {
                        'or': [
                            { '===': [{ var: 'data.action' }, 'aripost'] },
                            { '===': [{ var: 'data.action' }, 'swpage'] }
                        ]
                    },
                    { '!==': [{ var: 'data.actionType' }, ''] },
                    { '!==': [{ var: 'data.actionType' }, null] },
                    { 'not ': [{ var: 'data.actionType' }] }
                ]
            }
        },
    },
    //end Fiona  
    {
        type: 'textfield',
        inputType: 'url',
        key: 'url',
        input: true,
        weight: 120,
        label: 'Button URL',
        tooltip: 'The URL where the submission will be sent.',
        placeholder: 'https://example.ari.form',
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'url'] },
        },
    },
    //Simple
    {
        type: 'textfield',
        inputType: 'url',
        key: 'ariaction',
        input: true,
        weight: 120,
        label: 'Ari Action',
        tooltip: 'The API path that not included domain and API version.',
        placeholder: 'bo/bank/list',
        conditional: {
            json: {
                and: [
                    { '===': [{ var: 'data.action' }, 'aripost'] },
                    { '!==': [{ var: 'data.autodoaction' }, true] }
                ]
            }
        },
    },
    //End Simple
    //Fiona  - param for redirect
    {
        type: 'textfield',
        inputType: 'url',
        key: 'urltarget',
        input: true,
        weight: 120,
        label: 'Url Target',
        tooltip: 'The Url Target that not included params.',
        placeholder: '/path/to/new/url',
        conditional: {
            json: {
                and: [
                    { '===': [{ var: 'data.action' }, 'swpage'] },
                    { '!==': [{ var: 'data.autodoaction' }, true] },
                ]
            },
        },
    },
    {
        type: 'datagrid',
        key: 'headers',
        input: true,
        weight: 130,
        label: 'Headers',
        addAnother: 'Add Header',
        tooltip: 'Headers Properties and Values for your request',
        components: [
            {
                key: 'header',
                label: 'Header',
                input: true,
                type: 'textfield',
            },
            {
                key: 'value',
                label: 'Value',
                input: true,
                type: 'textfield',
            }
        ],
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'url'] },
        },
    },
    {
        type: 'datagrid',
        key: 'swpageParamGet',
        input: true,
        weight: 130,
        label: 'Url Params',
        addAnother: 'Add Param',
        tooltip: 'Param Query (URL)',
        components: [
            {
                key: 'key',
                label: 'Key',
                input: true,
                type: 'textfield',
            },
            {
                type: 'select',
                key: 'type',
                label: 'Type',
                input: true,
                dataSrc: 'values',
                data: {
                    values: [
                        { label: 'Value', value: 'value' },
                        { label: 'Data', value: 'data' },
                        { label: 'Script', value: 'script' },
                    ],
                },
                defaultValue: 'data'
            },
            {
                key: 'value',
                label: 'Value',
                input: true,
                //rows: 3,
                //editor: 'ace',
                as: 'javascript',
                type: 'textarea',
                attributes: {
                    style: 'height:calc(1.5em + .75rem + 2px)',
                },
                placeholder: '',
            }
        ],
        conditional: {
            json: {
                and: [
                    { '===': [{ var: 'data.action' }, 'swpage'] },
                    // { '===': [{ var: 'data.autodoaction' }, false] },
                ]
            },
        },
    },
    {
        type: 'checkbox',
        key: 'openNewTab',
        label: 'Open New Tab',
        input: true,
        weight: 155,
        tooltip: 'Open link in new tab',
        conditional: {
            json: {
                and: [
                    { '===': [{ var: 'data.action' }, 'swpage'] },
                ]
            },
        },
    },
    {
        type: 'select',
        key: 'resultType',
        label: 'Show toast for result',
        input: true,
        dataSrc: 'values',
        weight: 110,
        tooltip: 'Show toast',
        data: {
            values: [
                { label: 'None', value: 'none' },
                { label: 'Top right', value: 'toast-top-right' },
                { label: 'Bottom Right', value: 'toast-bottom-right' },
                { label: 'Bottom Left', value: 'toast-bottom-left' },
                { label: 'Top Left', value: 'toast-top-left' },
                { label: 'Top Full Width', value: 'toast-top-full-width' },
                { label: 'Bottom Full Width', value: 'toast-bottom-full-width' },
                { label: 'Top Center', value: 'toast-top-center' },
                { label: 'Bottom Center', value: 'toast-bottom-center' },
            ],
        },
        conditional: {
            json: {
                or: [
                    { '===': [{ var: 'data.action' }, 'aripost'] },
                    { '===': [{ var: 'data.action' }, 'bpmtask'] },
                    { '===': [{ var: 'data.action' }, 'bpmsubmit'] },
                    { '===': [{ var: 'data.action' }, 'bpmapprove'] },
                    { '===': [{ var: 'data.action' }, 'bpmreject'] },
                    { '===': [{ var: 'data.action' }, 'bpmsendback'] }
                ]
            }
        },
    },
    //End LanNTH
    {
        type: 'datagrid',
        key: 'headers',
        input: true,
        weight: 130,
        label: 'Headers',
        addAnother: 'Add Header',
        tooltip: 'Headers Properties and Values for your request',
        components: [
            {
                key: 'header',
                label: 'Header',
                input: true,
                type: 'textfield',
            },
            {
                key: 'value',
                label: 'Value',
                input: true,
                type: 'textfield',
            }
        ],
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'url'] },
        },
    },
    //Simple
    {
        type: 'datagrid',
        key: 'aribody',
        input: true,
        weight: 130,
        label: 'Request message body',
        addAnother: 'Add Node',
        tooltip: 'JSON body message structure',
        components: [
            {
                key: 'path',
                label: 'Path',
                input: true,
                type: 'textfield',
            },
            {
                type: 'select',
                key: 'type',
                label: 'Type',
                input: true,
                dataSrc: 'values',
                data: {
                    values: [
                        { label: 'Value', value: 'value' },
                        { label: 'Data', value: 'data' },
                        { label: 'Script', value: 'script' },
                    ],
                },
                defaultValue: 'data'
            },
            {
                key: 'value',
                label: 'Value',
                input: true,
                as: 'javascript',
                type: 'textarea',
                attributes: {
                    style: 'height:calc(1.5em + .75rem + 2px)',
                },
                placeholder: '',
            }
        ],
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'aripost'] },
        },
    },
    {
        type: 'textarea',
        key: 'ariOnSucess',
        label: 'Handle success response',
        tooltip: 'Javascript code logic to handle response',
        rows: 5,
        editor: 'ace',
        input: true,
        weight: 131,
        placeholder: 'Javascript code, eg: console.log(result)',
        defaultValue: "// utils.customShowPopUp(type,title,body,fullscreen,buttonName)\r\n\r\nutils.customShowPopUp(\r\n    'warning',\r\n    'Completed Credit application',\r\n    'Please wait while your information is being verified by Bank',\r\n    true,\r\n    'Back to the main page'\r\n).then((result) => {\r\n     if (result) {\r\n      utils. execExternalFunction('redirectUrl', '/');\r\n  } else {\r\n    //not do anything\r\n  }\r\n});",
        conditional: {
            json: {
                or: [
                    { '===': [{ var: 'data.action' }, 'aripost'] },
                    { '===': [{ var: 'data.action' }, 'bpmtask'] },
                    { '===': [{ var: 'data.action' }, 'bpmsubmit'] },
                    { '===': [{ var: 'data.action' }, 'bpmapprove'] },
                    { '===': [{ var: 'data.action' }, 'bpmreject'] },
                    { '===': [{ var: 'data.action' }, 'bpmsendback'] }
                ]
            }
        },
    },
    {
        type: 'checkbox',
        key: 'needOtp',
        label: 'Need Authentication',
        input: true,
        weight: 132,
        tooltip: 'Require Authentication for this action',
        conditional: {
            json: {
                or: [
                    { '===': [{ var: 'data.action' }, 'bpmtask'] },
                    { '===': [{ var: 'data.action' }, 'bpmsubmit'] },
                    { '===': [{ var: 'data.action' }, 'bpmapprove'] },
                    { '===': [{ var: 'data.action' }, 'bpmreject'] },
                    { '===': [{ var: 'data.action' }, 'bpmsendback'] }
                ]
            }
        },
    },
    {
        type: 'textarea',
        key: 'ariOnFail',
        label: 'Handle fail response',
        tooltip: 'Javascript code logic to handle response',
        rows: 5,
        editor: 'ace',
        input: true,
        weight: 132,
        placeholder: 'Javascript code, eg: console.log(result)',
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'aripost'] },
        },
    },
    //End Simple
    {
        type: 'textarea',
        key: 'custom',
        label: 'Button Custom Logic',
        tooltip: 'The custom logic to evaluate when the button is clicked.',
        rows: 5,
        editor: 'ace',
        input: true,
        weight: 120,
        placeholder: "data['mykey'] = data['anotherKey'];",
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'custom'] },
        },
    },
    {
        type: 'select',
        key: 'btnType',
        label: 'Button Type',
        input: true,
        tooltip: 'Type of this button.',
        dataSrc: 'values',
        weight: 140,
        defaultValue: 'contained',
        data: {
            values: [
                { label: 'Contained', value: 'contained' },
                { label: 'Outlined', value: 'outlined' },
                { label: 'Text', value: 'text' },
            ],
        },
    },
    {
        type: 'select',
        key: 'theme',
        label: 'Theme',
        input: true,
        tooltip: 'The color theme of this button.',
        dataSrc: 'values',
        weight: 140,
        data: {
            values: [
                { label: 'Primary', value: 'primary' },
                { label: 'Secondary', value: 'secondary' },
                { label: 'Info', value: 'info' },
                { label: 'Success', value: 'success' },
                { label: 'Danger', value: 'danger' },
                { label: 'Warning', value: 'warning' },
                { label: 'Fix bottom mobile', value: 'fixBottom' },
            ],
        },
    },
    {
        type: 'select',
        key: 'size',
        label: 'Size',
        input: true,
        tooltip: 'The size of this button.',
        dataSrc: 'values',
        weight: 150,
        data: {
            values: [
                { label: 'Small', value: 'sm' },
                { label: 'Medium', value: 'md' },
                { label: 'Large', value: 'lg' },
            ],
        },
    },
    {
        type: 'textfield',
        key: 'leftIcon',
        label: 'Left Icon',
        input: true,
        placeholder: 'Enter icon classes',
        tooltip: "This is the full icon class string to show the icon. Example: 'bi bi-plus'",
        weight: 160,
    },
    {
        type: 'textfield',
        key: 'rightIcon',
        label: 'Right Icon',
        input: true,
        placeholder: 'Enter icon classes',
        tooltip: "This is the full icon class string to show the icon. Example: 'bi bi-plus'",
        weight: 170,
    },
    {
        type: 'select',
        input: true,
        weight: 180,
        label: 'Shortcut',
        key: 'shortcut',
        tooltip: 'Shortcut for this component.',
        dataSrc: 'custom',
        valueProperty: 'value',
        customDefaultValue: () => '',
        template: '{{ item.label }}',
        data: {
            custom(context) {
                return builder_1.default.getAvailableShortcuts(lodash_1.default.get(context, 'instance.options.editForm', {}), lodash_1.default.get(context, 'instance.options.editComponent', {}));
            },
        },
    },
    {
        type: 'checkbox',
        key: 'showtooltipHover',
        label: 'Show Tooltip on Hover',
        input: true,
        weight: 190,
        tooltip: 'Show tooltip only on hover.',
    },
    {
        type: 'textfield',
        key: 'toolltipHover',
        label: 'Tooltip Hover Text',
        input: true,
        placeholder: 'Enter tooltip text',
        tooltip: "This is the text to show in the tooltip on hover.",
        weight: 191,
        conditional: {
            json: { '===': [{ var: 'data.showtooltipHover' }, true] },
        },
    },
    {
        type: 'select',
        key: 'tooltipPosition',
        label: 'Tooltip Position',
        input: true,
        tooltip: 'The position of the tooltip.',
        dataSrc: 'values',
        weight: 192,
        defaultValue: 'top',
        data: {
            values: [
                { label: 'Top', value: 'top' },
                { label: 'Bottom', value: 'bottom' },
                { label: 'Left', value: 'left' },
                { label: 'Right', value: 'right' },
            ],
        },
        conditional: {
            json: { '===': [{ var: 'data.showtooltipHover' }, true] },
        },
    },
    {
        type: 'checkbox',
        key: 'block',
        label: 'Block Button',
        input: true,
        weight: 155,
        tooltip: 'This control should span the full width of the bounding container.',
    },
    {
        type: 'checkbox',
        key: 'disableOnInvalid',
        label: 'Disable on Form Invalid',
        tooltip: 'This will disable this field if the form is invalid.',
        input: true,
        weight: 620,
    },
];
